<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 4H2.66659C1.93021 4 1.33325 4.59695 1.33325 5.33333V10.6667C1.33325 11.403 1.93021 12 2.66659 12H13.3333C14.0696 12 14.6666 11.403 14.6666 10.6667V5.33333C14.6666 4.59695 14.0696 4 13.3333 4Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
